import { SliceType } from 'components/MCTextEditor/slice/types'
import { ISmartLinkData } from 'components/MCTextEditor/types'
import {
  createDelete,
  createInsert,
} from 'components/RichTextEditor/processor/actions/textProcessorActions'
import { ITextProcessorMiddleware } from 'components/RichTextEditor/processor/constants'
import { createRange, shrinkRange } from 'components/RichTextEditor/processor/range'
import {
  getSlices,
  getText,
  getSelection,
} from 'components/RichTextEditor/processor/selectors/textProcessorSelectors'

export const createUpdateSmartLink =
  (getLabelById: (id: string) => string): ITextProcessorMiddleware =>
  (api) =>
  (next) =>
  (action) => {
    const result = next(action)
    if (!action || action.type !== 'render') {
      return result
    }

    const slicesLength = getSlices(api.getState()).length
    for (let i = 0; i < slicesLength; i++) {
      const state = api.getState()
      const slice = getSlices(state)[i]
      if (!slice || slice.type !== SliceType.SMART_LINK) {
        continue
      }
      const contentRange = shrinkRange(slice.range)
      if (!contentRange) {
        continue
      }
      const selection = getSelection(state)
      if (selection.length === 0 && selection.start === contentRange.start) {
        continue
      }
      const content = getLabelById((slice.data as ISmartLinkData).buttonId)
      const currentContent = getText(state).slice(contentRange.start, contentRange.end)
      if (content === currentContent) {
        continue
      }
      const newSlice = { ...slice, range: createRange(0, content.length) }
      api.dispatch(createInsert(contentRange.end, content, [newSlice]))
      api.dispatch(createDelete(contentRange.start, contentRange.length))
    }

    return result
  }
